import React from 'react';

export function LegTagBadge({ tag }: { tag?: string }) {
    if (tag === 'tainted') {
        return (
            <span className="px-1.5 py-0.5 text-[10px] font-bold uppercase rounded bg-amber-500/15 text-amber-700 dark:text-amber-300 border border-amber-500/25">
                Tainted
            </span>
        );
    }
    if (tag === 'mixed') {
        return (
            <span className="px-1.5 py-0.5 text-[10px] font-bold uppercase rounded bg-orange-500/15 text-orange-700 dark:text-orange-300 border border-orange-500/25">
                Mixed
            </span>
        );
    }
    return (
        <span className="px-1.5 py-0.5 text-[10px] font-bold uppercase rounded bg-emerald-500/15 text-emerald-700 dark:text-emerald-300 border border-emerald-500/25">
            Clean
        </span>
    );
}
